import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import type { AppDispatch } from "@/store"
import {
  submitOnboardingThunk,
  selectOnboardingIsLoading,
  selectOnboardingIsSubmitting,
  selectOnboardingSubmitError,
  selectOnboardingSubmitResult,
  selectOnboardingData,
  fetchEmployeeOnboardingThunk,
  updateOnboardingThunk,
  selectOnboardingIsUpdatingData,
} from "../store/employeeDetailsSlice"
import type { EmployeeOnboardingDetailsDto } from "@/modules/employee/employee/dto/employeeDetails"

export function useEmployeeOnboarding() {
  const dispatch = useDispatch<AppDispatch>()

  const isLoading = useSelector(selectOnboardingIsLoading)
  const isSubmitting = useSelector(selectOnboardingIsSubmitting)
  const isSavingData = useSelector(selectOnboardingIsUpdatingData)
  const onboardingData = useSelector(selectOnboardingData)
  const submitError = useSelector(selectOnboardingSubmitError)
  const submitResult = useSelector(selectOnboardingSubmitResult)

  const submitOnboarding = useCallback(
    (
      data: EmployeeOnboardingDetailsDto,
      requiredDocFiles?: Map<string, File>,
      signedDocFiles?: Map<string, File>,
    ) =>
      dispatch(
        submitOnboardingThunk({
          formData: data,
          requiredDocFiles,
          signedDocFiles,
        }),
      ).unwrap(),
    [dispatch],
  )

  const loadOnboardingData = useCallback(() => {
    dispatch(fetchEmployeeOnboardingThunk())
  }, [dispatch])

  const updateOnboardingData = useCallback((
    data: EmployeeOnboardingDetailsDto,
    requiredDocFiles?: Map<string, File>,
    signedDocFiles?: Map<string, File>,
  ) => {
    dispatch(updateOnboardingThunk({
      formData: data,
      requiredDocFiles,
      signedDocFiles,
    }))
  }, [dispatch])

  return {
    isLoading,
    isSubmitting,
    isSavingData,
    onboardingData,
    submitError,
    submitResult,
    submitOnboarding,
    loadOnboardingData,
    updateOnboardingData
  }
}
